import { AppState } from '../stores';
import PostCheckoutModalSvelte from '../../components/misc/PostCheckoutModal.svelte';
export function useModal() {
    const open = (component, options) => {
        AppState.update(previousState => (Object.assign(Object.assign({}, previousState), { website: Object.assign(Object.assign({}, previousState.website), { popoverOpen: !!(options === null || options === void 0 ? void 0 : options.keepPopoverOpen), fullscreenModal: {
                    component,
                    options,
                    isVisible: true
                } }) })));
    };
    const close = () => {
        AppState.update(previousState => (Object.assign(Object.assign({}, previousState), { website: Object.assign(Object.assign({}, previousState.website), { fullscreenModal: Object.assign(Object.assign({}, previousState.website.fullscreenModal), { isVisible: false }) }) })));
    };
    return {
        open,
        close
    };
}
/**
 * Custom modals open methods below
 */
export function usePostCheckoutModal() {
    const { open, close } = useModal();
    return {
        open: () => open(PostCheckoutModalSvelte, { disableScreenLockerCloseAction: true }),
        close
    };
}
